import React from 'react';
import { ExpirationDateInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/DateInput/ExpirationDateInput';
import { ExpiresOn } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';

export function DeactivationDateInputWrapper(): JSX.Element {
  const {
    formValues: { expiresOn },
  } = useMealCreditFormData();

  if (expiresOn === ExpiresOn.NEVER) {
    return null;
  }

  return <ExpirationDateInput id="expiration" name="expiration" />;
}
